module.exports = __webpack_public_path__ + "static/media/thenightly_app_download_image.a24907f7.webp";